// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SimilarStrollers__headline":"xh_a bhf_vn bhf_vf bhf_xb bhf_re bhf_tp bhf_qv"};